/**
 * BetterStack is off in local environments. The logger still prints to the console there, and it
 * still mirrors into Sentry when Sentry is on, which it is not in local either.
 * Gate on the app's own environment (`NEXT_PUBLIC_VIBRANT_ENV`), not on the source token: a token
 * in a developer's `.env` file would otherwise ship local logs to the production source.
 * There is no env override. To test BetterStack locally, change this guard and do not commit it.
 *
 * Reads the variable directly instead of `isLocal()` from `@/lib/environment`. The logger is
 * reached from almost every module, and a test that mocks `@/lib/environment` for its own module
 * would otherwise have to mock this too. The rule matches `getEnvironment()`: unset is local.
 */
export function shouldSendToBetterStack(): boolean {
  const environment = (process.env.NEXT_PUBLIC_VIBRANT_ENV ?? "").trim().toUpperCase();
  return environment !== "" && environment !== "LOCAL";
}
